var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AppConfig } from '../../config/config';
/**
 * Fetch search results from Searchspring Search API.
 * https://docs.searchspring.com/reference/get-search
 */
export function fetchSearchspring(r) {
    return __awaiter(this, void 0, void 0, function* () {
        const { siteId } = AppConfig.searchSettings.searchspring;
        let collectionHandle;
        let currentPage = 'search_page';
        const searchApp = document.querySelector('#search-app');
        if (searchApp) {
            collectionHandle = searchApp.dataset.collectionHandle;
            currentPage = searchApp.dataset.page || 'search_page';
        }
        const params = new URLSearchParams({
            siteId,
            resultsFormat: 'json',
            resultsPerPage: String(r.pageSize || 24),
            page: String(r.page || 1),
        });
        // Search query
        if (r.q && r.q !== '*') {
            params.append('q', r.q);
        }
        // Sort – format: sort.field=<field>&sort.direction=<asc|desc>
        if (r.sort && r.sort !== 'relevance') {
            const sortMap = {
                'ss_price:asc': { field: 'ss_price', direction: 'asc' },
                'ss_price:desc': { field: 'ss_price', direction: 'desc' },
                'title:asc': { field: 'title', direction: 'asc' },
                'title:desc': { field: 'title', direction: 'desc' },
                'ss_days_since_published:asc': { field: 'ss_days_since_published', direction: 'asc' },
                // Legacy mappings
                price_asc: { field: 'ss_price', direction: 'asc' },
                price_desc: { field: 'ss_price', direction: 'desc' },
                title_asc: { field: 'title', direction: 'asc' },
                title_desc: { field: 'title', direction: 'desc' },
            };
            const mapped = sortMap[r.sort];
            if (mapped) {
                params.append(`sort.${mapped.field}`, mapped.direction);
            }
            else if (r.sort.includes(':')) {
                const [field, direction] = r.sort.split(':');
                params.append(`sort.${field}`, direction);
            }
        }
        // Customer-applied filters
        if (r.filters) {
            for (const [field, values] of Object.entries(r.filters)) {
                for (const value of values) {
                    // Range filters: value format is "low-high" (e.g. "10-20", "*-10", "1000-*")
                    // or "low,high" from slider — send as filter.<field>.low / filter.<field>.high
                    const rangeMatch = value.match(/^(\*|\d+(?:\.\d+)?)[,\-](\*|\d+(?:\.\d+)?)$/);
                    if (rangeMatch) {
                        const [, low, high] = rangeMatch;
                        if (low !== '*')
                            params.append(`filter.${field}.low`, low);
                        if (high !== '*')
                            params.append(`filter.${field}.high`, high);
                    }
                    else {
                        params.append(`filter.${field}`, value);
                    }
                }
            }
        }
        // Background filters (category pages, pre-filtering)
        if (r.bgFilters) {
            for (const [field, values] of Object.entries(r.bgFilters)) {
                for (const value of values) {
                    params.append(`bgfilter.${field}`, value);
                }
            }
        }
        // Scope to collection on collection pages
        if (collectionHandle) {
            params.append('bgfilter.collection_handle', collectionHandle);
        }
        const endpoint = currentPage === 'collection_page' ? 'category.json' : 'search.json';
        const url = `https://${siteId}.a.searchspring.io/api/search/${endpoint}?${params.toString()}`;
        const response = yield fetch(url, {
            headers: { 'Accept': 'application/json' },
        });
        if (!response.ok) {
            throw new Error(`Searchspring API error: ${response.status} ${response.statusText}`);
        }
        return response.json();
    });
}
